/**
 * HelpscoutLogo/index.js
 * desc: Helpscout product logo
 * note: renders an accessible button (aria-label) when given an onClick handler; otherwise a static figure
 */
'use strict';

import IconButton from '../IconButton';


const HelpscoutLogo = (props) => (
    <IconButton baseClassName="helpscout logo" label="Help Scout" tooltip={ null } { ...props }>
        <svg viewBox="-27 0 310 310" version="1.1" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid">
            <g><path d="M18.432,180.968727 L108.916364,90.4843636 C120.645818,78.9410909 127.906909,62.7432727 127.906909,45.056 C127.906909,27.5549091 120.832,11.5432727 109.474909,0 L18.9905455,90.4843636 C7.26109091,102.027636 0,118.225455 0,135.912727 C0,153.6 7.07490909,169.425455 18.432,180.968727 Z M237.568,128.093091 L147.083636,218.577455 C135.354182,230.120727 128.093091,246.318545 128.093091,264.005818 C128.093091,281.506909 135.168,297.518545 146.525091,309.061818 L237.009455,218.577455 C248.738909,207.034182 256,190.836364 256,173.149091 C256,155.461818 248.925091,139.636364 237.568,128.093091 Z M237.009455,90.6705455 C248.738909,79.1272727 256,62.9294545 256,45.2421818 C256,27.7410909 248.925091,11.7294545 237.568,0.186181818 L18.9905455,218.577455 C7.26109091,230.306909 0,246.318545 0,264.192 C0,281.693091 7.07490909,297.704727 18.432,309.248 L237.009455,90.6705455 Z" fill="#1292EE"></path></g>
        </svg>
    </IconButton>
);


export default HelpscoutLogo;
